// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoTooltip_root__2_aIg","tooltiptext":"InfoTooltip_tooltiptext__3fvJI"};